var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser'; // import { logErrorToAppInsights } from './AppInsights';
import { azureAADPublicClientApplication, scopesToUse } from './Auth'; /**
 * Handles delaying a token.  Helps manage local time sync issue.
 *
 * **Should only be used in local dev**
 */
var delayToken = function () { if (process.env.NODE_ENV === 'development') {
    return new Promise(function (resolve) { return setTimeout(resolve, 1000); });
} }; /**
* Catches any unexpected error.
* Logs to App Insights and redirects to Error Page.
*/
var handleTokenError = function (error) { console.log(error); logoutRedirect(); }; // Multiple callers (Apollo requests, Header) can hit a token failure at the same
// moment. MSAL only allows one interaction at a time, so guard against firing
// overlapping/duplicate redirects, which otherwise fail silently and leave the
// user stuck on the page with no way to re-authenticate.
var isRedirectingToLogin = false; /**
 * Causes a log out and prompts the user to log back in.
 * Redirect url is set to return them to the page they were on.
 */
export var logoutRedirect = function () { return __awaiter(void 0, void 0, void 0, function () { var logoutRequest; return __generator(this, function (_a) {
    switch (_a.label) {
        case 0:
            if (isRedirectingToLogin) {
                return [2 /*return*/];
            }
            isRedirectingToLogin = true;
            logoutRequest = { postLogoutRedirectUri: window.location.href };
            return [4 /*yield*/, azureAADPublicClientApplication.logoutRedirect(logoutRequest).catch(function (error) { console.log(error); isRedirectingToLogin = false; })];
        case 1:
            _a.sent();
            return [2 /*return*/];
    }
}); }); }; /**
* Handles fetching an access token for Apollo or Rest calls.
*
* Verifies the user is authenticated and has an active account.
* Then grabs either an access token from cache or uses the refresh token to
* obtain a new access token.
*
* Handles errors by either logging user out to be re-authenticated or by logging an
* error to App Insights.
*/
export var fetchFreshToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var tokenResponse, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fetchAndSetActiveAccount();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, azureAADPublicClientApplication.acquireTokenSilent({ scopes: scopesToUse })];
            case 2:
                tokenResponse = _a.sent();
                if (!(process.env.NODE_ENV === 'development')) return [3 /*break*/, 4];
                return [4 /*yield*/, delayToken()];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/, tokenResponse.accessToken ? tokenResponse.accessToken : tokenResponse.idToken];
            case 5:
                error_1 = _a.sent();
                // such as a token expired, try the redirect
                if (error_1 instanceof InteractionRequiredAuthError || error_1 instanceof BrowserAuthError) {
                    logoutRedirect();
                }
                else {
                    handleTokenError(error_1);
                }
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); }; /**
 * Handles fetching an setting an Active account for a user.
 *
 * If no account can be found for the user, log them out to be
 * re-authenticated.
 *
 * Handles errors by either logging user out to be re-authenticated or by logging an
 * error to App Insights.
 */
export var fetchAndSetActiveAccount = function () {
    try {
        if (!!azureAADPublicClientApplication.getActiveAccount()) { }
        else {
            var _azureAADPublicClient;
            if (((_azureAADPublicClient = azureAADPublicClientApplication.getAllAccounts()) === null || _azureAADPublicClient === void 0 ? void 0 : _azureAADPublicClient.length) > 0) {
                azureAADPublicClientApplication.setActiveAccount(azureAADPublicClientApplication.getAllAccounts()[0]);
            }
            else { // If no account is found, log them out.
                logoutRedirect();
            }
        }
    }
    catch (error) {
        handleTokenError(error);
    }
};
